var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6378 9.3878L13.5128 17.5128C13.4373 17.5883 13.3477 17.6483 13.2491 17.6892C13.1505 17.73 13.0447 17.7511 12.938 17.7511C12.8312 17.7511 12.7254 17.73 12.6268 17.6892C12.5282 17.6483 12.4386 17.5883 12.3631 17.5128L4.23811 9.3878C4.08565 9.23534 4 9.02856 4 8.81295C4 8.59734 4.08565 8.39057 4.23811 8.23811C4.39057 8.08565 4.59734 8 4.81295 8C5.02856 8 5.23534 8.08565 5.3878 8.23811L12.938 15.7893L20.4881 8.23811C20.5636 8.16262 20.6532 8.10274 20.7519 8.06188C20.8505 8.02103 20.9562 8 21.063 8C21.1697 8 21.2754 8.02103 21.3741 8.06188C21.4727 8.10274 21.5623 8.16262 21.6378 8.23811C21.7133 8.3136 21.7732 8.40322 21.814 8.50185C21.8549 8.60048 21.8759 8.70619 21.8759 8.81295C21.8759 8.91971 21.8549 9.02542 21.814 9.12406C21.7732 9.22269 21.7133 9.31231 21.6378 9.3878Z",
    fill: "#212122"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.1a5d54d4df75fa09113f2a8235fdb8c4.svg";
export { ForwardRef as ReactComponent };